
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcements/[slug]",
      function () {
        return require("private-next-pages/announcements/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/announcements/[slug]"])
      });
    }
  